import { makeChartComp } from '../../util/makeChartComp';
var ColumnChart = makeChartComp('Column');
export default ColumnChart;
